import React, { useEffect, useState } from "react";
import { Leaf } from "lucide-react";
import { goToCheckout } from "@/lib/checkout";
import { trackInitiateCheckout } from "@/lib/analytics";

const LINKS = [
  { href: "#inicio", label: "Inicio" },
  { href: "#contenido", label: "Contenido" },
  { href: "#por-edades", label: "Por edad" },
  { href: "#testimonios", label: "Testimonios" },
  { href: "#bonos", label: "Bonos" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleCheckout = () => {
    trackInitiateCheckout("nav-cta");
    setTimeout(() => goToCheckout(), 120);
  };

  return (
    <header
      data-testid="navbar"
      className={`sticky top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#F4EBDE]/85 backdrop-blur-xl border-b border-[#E8DDC9]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-6">
        <a href="#inicio" className="flex items-center gap-2.5 shrink-0" data-testid="nav-brand">
          <div className="flex flex-col leading-none">
            <span className="font-serif-display text-2xl md:text-[26px] text-[#2A302A] flex items-center gap-1.5">
              Pequeños Platos
              <Leaf className="h-4 w-4 text-[#849983]" strokeWidth={1.7} />
            </span>
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#8A948A] mt-1 font-medium">
              Nutrición que abraza
            </span>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[13px] tracking-wide font-semibold uppercase text-[#576057] hover:text-[#2A302A] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="nav-cta"
          onClick={handleCheckout}
          className="hidden sm:inline-flex items-center gap-1 bg-[#849983] hover:bg-[#6F856E] text-white rounded-full px-5 lg:px-7 py-3 text-xs lg:text-[13px] font-semibold tracking-wider transition-all duration-300 shadow-[0_8px_22px_rgba(132,153,131,0.35)] hover:-translate-y-0.5 whitespace-nowrap"
        >
          QUIERO EMPEZAR AHORA
        </button>
      </div>
    </header>
  );
}
